import React from 'react'
import styles from './designed.module.css'

export default function Designed({ style, value, date, id }) {

  return (
    <div id={id ? id : 'containerDesigned'} className={styles.container}>
      <div className={styles.content}>
        <label style={style} className={styles.sign}>{value}</label>
        <div className={styles.txt}>
          <label className={styles.disignedTxt}>DKBSigned By :</label>
          {/* <label className={styles.dateTxt}>{date}</label> */}
        </div>
      </div>
    </div>
  )
}
